










































































































import {
    Vue,
    Component,
    Prop,
} from "@/shared/vuepack";
import { PartnerUser } from "@/shared/types";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
      Button
    }
})

export default class PartnerUserEditModal extends Vue {
    $validator: Validator;
    @Prop() partnerUser: PartnerUser;
    @Prop() onPartnerUserEditModalClose;
    @Prop() onPartnerUserEditModalSave;
    themeStore = useThemeStore();

    savePartnerUser (): void {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.onPartnerUserEditModalSave(this.partnerUser);
        }});
    }
}

